module.exports = __webpack_public_path__ + "media/images/japan/nav_5-77b48ef923b6cd2373ba99dc7cd0492f.svg";